import { api } from '@/config'

export async function getEmptyUser() {
  const res = await api.get('users/emptyuser')
  if (res.status !== 200) {
    throw { response }
  }
  return res.data
}
